import { FilePreviewAccessEnum, IFilePreview } from "tir-components";

export class LoadingFileModel implements IFilePreview {
  /**ID изображения */
  FileId: number;
  /**Ссылка на файл */
  Url: string;
  /**Название файла */
  Name: string;
  /**Размер файла */
  Size: number;
  /**Доступы к файлу */
  Accesses?: Array<FilePreviewAccessEnum> = [FilePreviewAccessEnum.Remove];
  /**Прогресс */
  Progress!: number;
  /**Файл в обработке */
  readonly IsProccessing: boolean = false;

  constructor(obj?: Omit<Partial<LoadingFileModel>, "IsProccessing">) {
    Object.assign(this, obj);
  }
}
